<div class="uni-card" [class.alarm]="hasAlarm">
  <div class="uni-card-head">
    <span class="uni-name">{{ channel.name || ('uni.kind.' + channel.kind | translate) }}</span>
    <span class="uni-alarm" *ngIf="hasAlarm" [title]="'uni.alarm' | translate">⚠</span>
  </div>

  <!-- WATER_LEVEL -->
  <div class="uni-body" *ngIf="kind === 'WaterLevel'">
    <div class="uni-metric">
      <span class="uni-value">{{ levelText | translate }}</span>
      <span class="uni-unit">{{ 'uni.level' | translate }}</span>
    </div>
  </div>

  <!-- PRESSURE_ADC -->
  <div class="uni-body" *ngIf="kind === 'PressureAdc'">
    <div class="uni-metric">
      <span class="uni-value">{{ pressureText }}<small *ngIf="pressureUnitKey"> {{ pressureUnitKey | translate }}</small></span>
      <span class="uni-unit">{{ 'uni.pressure' | translate }}</span>
    </div>
  </div>

  <!-- DS18B20 -->
  <div class="uni-body" *ngIf="kind === 'Ds18b20'">
    <div class="uni-metric">
      <span class="uni-value">{{ scaled('TEMPERATURE') }}<small>°C</small></span>
    </div>
  </div>

  <!-- FAN_PWM_TACH -->
  <div class="uni-body" *ngIf="kind === 'FanPwmTach'">
    <div class="uni-row">
      <span class="uni-value">{{ val('FAN_RPM') ?? '—' }}<small> {{ 'uni.rpm' | translate }}</small></span>
      <span class="uni-sub">{{ dutyPct }}%</span>
    </div>
    <div class="uni-controls" *ngIf="canConfigure">
      <label class="uni-toggle">
        <input type="checkbox" [checked]="isManual" (change)="setMode($any($event.target).checked)">
        {{ 'uni.manual_mode' | translate }}
      </label>
      <input *ngIf="isManual" type="range" min="0" max="100" step="5"
             [value]="dutyPct" (change)="setDuty($any($event.target).value)">
    </div>
  </div>

  <!-- BOILER_RINNAI -->
  <div class="uni-body" *ngIf="kind === 'BoilerRinnai'">
    <div class="uni-row">
      <span class="uni-value">{{ scaled('TEMPERATURE') }}<small>°C</small></span>
      <span class="uni-flame" [class.lit]="flame" [title]="'uni.burner' | translate">🔥</span>
    </div>
    <div class="uni-controls" *ngIf="canConfigure">
      <button class="uni-power" [class.on]="on" (click)="togglePower()">
        {{ (on ? 'uni.turn_off' : 'uni.turn_on') | translate }}
      </button>
      <label class="uni-target">
        {{ 'uni.setpoint' | translate }}
        <select [value]="targetC" (change)="setTarget($any($event.target).value)">
          <option *ngFor="let t of allowed" [value]="t">{{ t }}°C</option>
        </select>
      </label>
      <span class="uni-pending" *ngIf="targetC !== ( (val('TARGET_TEMP')||0)/100 )">…</span>
    </div>
  </div>

  <!-- MODBUS_SWITCH (pump) -->
  <div class="uni-body" *ngIf="kind === 'ModbusSwitch'">
    <div class="uni-row">
      <label class="uni-switch">
        <input type="checkbox" [checked]="on" [disabled]="!canConfigure"
               (change)="setSwitch($any($event.target).checked)">
        <span>{{ (on ? 'common.on' : 'common.off') | translate }}</span>
      </label>
      <span class="uni-badge" *ngIf="params.mode === 'thermoFollow'">{{ 'uni.thermo_follow' | translate }}</span>
    </div>
  </div>
</div>
